module.exports = __webpack_public_path__ + "public/img/prakerja-border.556c0f4b.png";